import { initializeYup } from "@duosoftbg/nacid-components";
import * as yup from "yup";

export const seRecognitionSearchValidationSchema = () => {
  initializeYup(yup);
  return yup.object({});
};
